import { query } from '@confluence/query-preloader-tools';
import { expVal } from '@confluence/feature-experiments';

import { ViewSpaceExternalCollaboratorsDialogQuery } from './graphql/ViewSpaceExternalCollaboratorsDialogQuery.graphql';

export function preloadSpaceGuestList(spaceKey: string) {
	if (expVal('confluence_unified_space_preloader', 'isEnabled', false)) {
		return Promise.resolve();
	}
	return query({
		query: ViewSpaceExternalCollaboratorsDialogQuery,
		variables: {
			spaceKey,
		},
	});
}
